import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, UrlTree } from '@angular/router';
import { Auth0Service } from '@geneplanet/ngx-auth0';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CustomerCheckService } from 'src/app/shared/services/customer-check.service';
import { IntentStrategyService } from 'src/app/shared/services/intent/intent-strategy.service';

@Injectable({ providedIn: 'root' })
export class CustomerExistsGuard implements CanActivate, CanActivateChild {
  constructor(
    private customerCheck: CustomerCheckService,
    private intentStrategyService: IntentStrategyService,
    private auth0Service: Auth0Service
  ) {}

  getCanActive(): Observable<boolean | UrlTree> {
    return this.customerCheck.customerExists$.pipe(
      switchMap((exists: boolean) => {
        if (exists) {
          return of(true);
        }

        const isUserLoggedIn = !!this.auth0Service.tokens.current$.value;

        if (isUserLoggedIn) {
          return this.intentStrategyService.context.onCustomerNotExists();
        } else {
          return this.intentStrategyService.context.onUserNotExists();
        }
      })
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.getCanActive();
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.getCanActive();
  }
}
